import { getTextFromHtml } from '@features/modal-invitation/lib/getTextFromHtml';
import { sanitizeEditorHtml } from '@shared/libs/sanitize-editor-html';
import { InvitationLinkIcon } from '../../../InvitationLinkIcon';
import styles from './invitation-preview.module.scss';

interface InvitationPreviewProps {
  isSmsInvitationMode: boolean;
  invitationText: string;
  previewLink: string;
}

export const InvitationPreview = ({ isSmsInvitationMode, invitationText, previewLink }: InvitationPreviewProps) => {
  const hasInvitationContent = !!getTextFromHtml(invitationText).trim();

  return (
    <div className={styles.settingsCardPreviewBlock}>
      <div className={styles.settingsCardPreviewContent}>
        <div className={styles.settingsCardPreviewSection}>
          <h3 className={styles.settingsCardPreviewLabel}>Предварительный просмотр приглашения</h3>
          <div className={styles.settingsCardPreviewContentInner}>
            {hasInvitationContent &&
              (isSmsInvitationMode ? (
                <div className={styles.settingsCardPreviewMessage}>{invitationText}</div>
              ) : (
                <div className={styles.settingsCardPreviewMessage}>
                  <div dangerouslySetInnerHTML={{ __html: sanitizeEditorHtml(invitationText) }} />
                </div>
              ))}
            <div className={styles.settingsCardPreviewLinkRow}>
              <InvitationLinkIcon />
              <div className={styles.settingsCardPreviewLink}>{previewLink}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
